<template>
    <section class="contact-cta py-5">
        <div class="container">
            <div class="cta-wrapper text-center py-5">
                <h2 class="mb-4">Potrzebujesz profesjonalnej obsługi księgowej?</h2>
                <p class="lead mb-4">Skontaktuj się z nami i umów się na bezpłatną konsultację. Odpowiemy na wszystkie
                    Twoje pytania.</p>
                <div class="d-flex justify-content-center gap-3">
                    <router-link to="/kontakt" class="btn btn-primary btn-lg">Skontaktuj się</router-link>
                    <a href="tel:+48571464177" class="btn btn-outline-primary btn-lg">
                        <i class="fas fa-phone me-2"></i>+48 571 464 177
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ContactCta'
}
</script>

<style lang="scss" scoped>
.contact-cta {
    background-color: #f1f8ff;

    .cta-wrapper {
        background-color: white;
        border-radius: 12px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        padding: 3rem 2rem;

        h2 {
            color: var(--primary-color);
        }

        .lead {
            color: #6c757d;
            max-width: 700px;
            margin-left: auto;
            margin-right: auto;
        }
    }
}
</style>